import { useState } from "react";
import { useNavigate } from "@tanstack/react-router";
import { useForm } from "@tanstack/react-form";
import { Search, X } from "lucide-react";
import { DISTANCE_OPTIONS } from "./business-search-form";
import "../styles/components/navbar-search.css";

const CLOSE_DURATION = 350;

export default function NavbarSearch() {
  const [isOpen, setIsOpen] = useState(false);
  const [isClosing, setIsClosing] = useState(false);
  const navigate = useNavigate();

  const form = useForm({
    defaultValues: { search: "", address: "", distance: "" },
    onSubmit: async ({ value }) => {
      const trimmed = { search: value.search.trim(), address: value.address.trim(), distance: value.distance };
      if (!trimmed.search && !trimmed.address && !trimmed.distance) {
        return;
      }
      navigate({ to: "/", search: trimmed });
      close();
    },
  });

  function close() {
    if (isClosing) {
      return;
    }
    setIsClosing(true);
    setTimeout(() => {
      setIsOpen(false);
      setIsClosing(false);
      form.reset();
    }, CLOSE_DURATION);
  }

  const showOverlay = isOpen || isClosing;

  return (
    <div className={`navbar-search${showOverlay ? " navbar-search--open" : ""}`}>
      <button className="navbar-search__btn" type="button" onClick={() => setIsOpen(true)} aria-label="Search">
        <Search size={18} />
      </button>

      {showOverlay && (
        <form
          className={`navbar-search__overlay${isClosing ? " navbar-search__overlay--closing" : ""}`}
          onSubmit={(e) => {
            e.preventDefault();
            form.handleSubmit();
          }}
          onKeyDown={(e) => {
            if (e.key === "Escape") {
              close();
            }
          }}
        >
          <div className="navbar-search__fields">
            <form.Field name="search">
              {(field) => (
                <input
                  // eslint-disable-next-line jsx-a11y/no-autofocus
                  autoFocus
                  type="text"
                  className="navbar-search__input"
                  placeholder="Business or keyword…"
                  value={field.state.value}
                  onChange={(e) => field.handleChange(e.target.value)}
                  onBlur={field.handleBlur}
                />
              )}
            </form.Field>
            <div className="navbar-search__divider navbar-search__divider--address" />
            <form.Field name="address">
              {(field) => (
                <input
                  type="text"
                  className="navbar-search__input navbar-search__input--address"
                  placeholder="Address or suburb…"
                  value={field.state.value}
                  onChange={(e) => field.handleChange(e.target.value)}
                  onBlur={field.handleBlur}
                />
              )}
            </form.Field>
            <div className="navbar-search__divider navbar-search__divider--distance" />
            <form.Field name="distance">
              {(field) => (
                <select
                  className="navbar-search__select"
                  value={field.state.value}
                  onChange={(e) => field.handleChange(e.target.value)}
                  onBlur={field.handleBlur}
                >
                  {DISTANCE_OPTIONS.map((opt) => (
                    <option key={opt.value} value={opt.value}>
                      {opt.label}
                    </option>
                  ))}
                </select>
              )}
            </form.Field>
          </div>

          <button type="button" className="navbar-search__close" onClick={close} aria-label="Close search">
            <X size={14} />
          </button>

          <button type="submit" className="navbar-search__submit" aria-label="Search">
            <Search size={16} />
          </button>
        </form>
      )}
    </div>
  );
}
